import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';

import getLoginLink from './utils/getLoginLink';

import {
  PrimaryButtonSmall,
  TertiaryButtonSmall,
  TextButtonSmall,
} from '@xingternal/malt-button';
import ButtonGroup from '@xingternal/malt-button-group';

const LoggedOutSubHeader = ({
  hasCTA,
  loginLink,
  signupLink,
  whiteBG,
  styles,
}) => {
  const SignUpButton = hasCTA ? PrimaryButtonSmall : TertiaryButtonSmall;
  const signupButtonClasses = classNames({
    [styles.tertiaryButton]: !hasCTA && !whiteBG,
  });
  const loginButtonClasses = classNames({
    [styles.buttonAdjustment]: !whiteBG,
  });
  return (
    <nav className={styles.linkGroup}>
      <ButtonGroup>
        <TextButtonSmall href={loginLink} className={loginButtonClasses}>
          <FormattedMessage id="X_UI_NAVIGATION_LOGIN_FRAME_FALLBACK" />
        </TextButtonSmall>
        <SignUpButton href={signupLink} className={signupButtonClasses}>
          <FormattedMessage id="X_UI_HEADER_REGISTER" />
        </SignUpButton>
      </ButtonGroup>
    </nav>
  );
};

LoggedOutSubHeader.defaultProps = {
  hasCTA: false,
  signupLink: '/signup',
  whiteBG: false,
  loginLink: getLoginLink(),
};

LoggedOutSubHeader.propTypes = {
  hasCTA: PropTypes.bool,
  loginLink: PropTypes.string,
  signupLink: PropTypes.string,
  whiteBG: PropTypes.bool,
  styles: PropTypes.object.isRequired,
};

export default LoggedOutSubHeader;
